import { IGetGroupJwtRequestParams, JwtTokenFullData } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { resolveJWTWithApiKey } from 'modules/common/utils/resolveJWTWithApiKey';
import { web3Api } from 'store/queries';

export interface IFetchTeamAccountJWTParams extends IGetGroupJwtRequestParams {}

const fetchTeamAccountJWTFallback: JwtTokenFullData = {};

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchTeamAccountJWT },
  useFetchTeamAccountJWTQuery,
  useLazyFetchTeamAccountJWTQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchTeamAccountJWT: build.query<
      JwtTokenFullData,
      IFetchTeamAccountJWTParams
    >({
      queryFn: async ({ group }) => {
        const api = MultiService.getService().getAccountingGateway();

        const jwt = await api.getGroupJwtTokenWithApiKey({ group });

        // a group JWT is never encrypted
        const data = await resolveJWTWithApiKey({
          ...jwt,
          is_encrypted: false,
        });

        return { data };
      },
    }),
  }),
});

export const {
  selectDataWithFallbackCachedByParams: selectTeamAccountJWT,
  selectLoadingCachedByParams: selectTeamAccountJWTLoading,
  selectStateCachedByParams: selectTeamAccountJWTState,
} = createQuerySelectors({
  endpoint: fetchTeamAccountJWT,
  fallback: fetchTeamAccountJWTFallback,
});
